import { DataTable } from "@/components/composables/DataTable";
import {
  useGetAllMerchantTerminal,
} from "../_misc/mutations";
import { Checkbox } from "@/components/ui/checkbox";
import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import useControl from "@/hooks/useControl";
import { useState } from "react";
import moment from "moment";
import { Terminal } from "../_misc/types";
import Pagination from "../_misc/pagination";
import ViewTerminalModal from "../_misc/viewTerminalModal";
import Options from "../_misc/terminalOptions";

const Terminals = () => {
  // const { state: isOpen, setTrue: onOpen, setFalse: onClose } = useControl()
  // const { state: isOpenEdit, setTrue: onOpenEdit, setFalse: onCloseEdit } = useControl()

  const {
    state: isOpenViewModal,
    setTrue: onOpenViewModal,
    setFalse: onCloseViewModal,
  } = useControl();
  //
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isPending } = useGetAllMerchantTerminal({
    size: 10,
    page: currentPage,
  });

  const [, setTransactionId] = useState("");
  const [terminal, setTerminal] = useState<Terminal>();
  // const pageSize = 10; // Number of transactions per page
  const totalPages = data?.totalPages as number;

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const columns: ColumnDef<Terminal>[] = [
    {
      id: "select",
      header: ({ table }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "terminalId",
      header: "Terminal ID",
      cell: ({ row }) => <div>{row.original.terminalId}</div>,
    },
    {
      accessorKey: "terminalName",
      header: "Terminal Name",
      cell: ({ row }) => <div>{row.original.terminalName}</div>,
    },
    {
      accessorKey: "serialNumber",
      header: "Serial Number",
      cell: ({ row }) => <div>{row.original.serialNumber}</div>,
    },
    {
      accessorKey: "terminalModel",
      header: "Terminal Model",
      cell: ({ row }) => <div>{row.original.terminalModel}</div>,
    },
    {
      accessorKey: "merchantId",
      header: "Merchant ID",
      cell: ({ row }) => <div>{row.original.merchantId}</div>,
    },
    {
      accessorKey: "terminalAddress",
      header: "Terminal Address",
      cell: ({ row }) => (
        <div>
          {row.original.terminalAddress
            ? `${row.original.terminalAddress[0].toUpperCase()}${row.original.terminalAddress.slice(1)}`
            : "N/A"}
        </div>
      ),
    },
    {
      accessorKey: "approvalStatus",
      header: "Approval Status",
      cell: ({ row }) => <div>{row.original.approvalStatus || "N/A"}</div>,
    },
    {
      accessorKey: "isEnabled",
      header: "Status",
      cell: ({ row }) => (
        <Badge status={row.original.isEnabled ? "Active" : "Inactive"} />
      ),
    },
    {
      accessorKey: "customerType",
      header: "Customer Type",
      cell: ({ row }) => <div>{row.original.customerType}</div>,
    },
    {
      accessorKey: "transactionLimit",
      header: "Transaction Limit",
      cell: ({ row }) => <div>{row.original.transactionLimit}</div>,
    },
    {
      accessorKey: "maximumAmount",
      header: "Maximum Amount",
      cell: ({ row }) => (
        <div>₦{row.original.maximumAmount.toLocaleString()}</div>
      ),
    },
    {
      accessorKey: "createdAt",
      header: "Created At",
      cell: ({ row }) => (
        <div>{moment(row.original.createdAt).format("LLLL")}</div>
      ),
    },
    {
      id: "actions",
      cell: ({ row }) => (
        <Options
          setTransactionId={setTransactionId}
          setTransaction={() => setTerminal(row.original)}
          id={row.original._id}
          onOpenView={onOpenViewModal}
        />
      ),
    },
  ];

  return (
    <div>
      <DataTable
        isLoading={isPending}
        columns={columns}
        data={(data ?? []) as Terminal[]}
      />
      <div className="flex justify-end">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>

      {isOpenViewModal && (
        <ViewTerminalModal
          onClose={onCloseViewModal}
          terminal={terminal as Terminal}
        />
      )}
    </div>
  );
};

export default Terminals;
